import React, { useState } from 'react'

import type { F0TimelineRowAction } from '@factorialco/f0-react'
import { CheckCircleLine } from '@factorialco/f0-react/icons/app'
import {
  PurchaseRequestDetailDocument,
  UpdateTaskStatusesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface TimelineTaskCompleteActionsRenderProps {
  primaryAction: F0TimelineRowAction
}

interface TimelineTaskCompleteActionsProps {
  taskId: string
  children: (props: TimelineTaskCompleteActionsRenderProps) => React.ReactNode
}

const TimelineTaskCompleteActions = ({ taskId, children }: TimelineTaskCompleteActionsProps) => {
  const [completed, setCompleted] = useState(false)

  const [updateTaskStatuses, { loading }] = useMutation(UpdateTaskStatusesDocument, {
    extractorFn: (data) => data.tasksMutations.bulkMarkAsTasksInboxTask,
    refetchQueries: [PurchaseRequestDetailDocument],
  })

  const handleComplete = async () => {
    const result = await updateTaskStatuses({
      variables: {
        taskIds: [taskId],
        status: 'done',
      },
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('tasks.responses.mark_as_done_failed'),
      })
    })

    if (handled.success) {
      setCompleted(true)
      app.setFlash({
        type: 'correct',
        message: i18n.t('tasks.responses.mark_as_done'),
      })
    }
  }

  const primaryAction: F0TimelineRowAction = {
    label: i18n.t('tasks.mark.done'),
    icon: CheckCircleLine,
    onClick: handleComplete,
    disabled: loading || completed,
  }

  return <>{children({ primaryAction })}</>
}

export default TimelineTaskCompleteActions
